import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import { getToken, isAuthenticated } from '../../store/auth';
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'
import { isBlank } from '../../helpers/stringHelper'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { listaAction } from '../../store/lista';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Return, Select } from '../inspinia';
import CircularProgress from '@material-ui/core/CircularProgress';

import TemPermissao from '../../helpers/TemPermissao';
import { ROLE_EMAIL, ROLE_SMS } from '../../store/roles';

class ListaUploadValidar extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state =
        {
            loading: false,
            form: this.formInitialState(),
            file: null,

            comboTipoListaContato: {
                results: undefined
            },
            tipoListaContatoUnico: false,
            idLista: '',

            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } }
        }
        this.handleSave = this.handleSave.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
        this.loadListaContatoValidar = this.loadListaContatoValidar.bind(this);
    }

    formInitialState() {
        return {
            file: "",
            nomeArquivo: "",
            tipoListaContato: "",
        }
    }

    componentDidMount() {
        let self = this;
        const idLista = self.props.location.pathname.split('/')[5];

        if (idLista != undefined) {
            this.loadListaContatoValidar(idLista);
        }

        this.loadTipoListaContato();
    }

    loadListaContatoValidar(idLista) {
        let self = this;

        const url = `${c.API_BASE_URL}/list-validate/show/to-update/${idLista}`;
        const options = self.state.optionsGet;

        callApi(url, options, (response) => {
            self.setState({
                ...self.state,
                idLista: response.id,
                form: {
                    ...self.state.form,
                    nomeArquivo: response.nomeArquivo,
                    tipoListaContato: response.tipoListaContato
                }
            });
        });
    }

    loadTipoListaContato() {
        self = this;

        const url = `${c.API_BASE_URL}/combo-tipo-lista-contato`;
        const options = { method: 'GET', headers: { 'Content-Type': 'application/json' } };

        callApi(url, options, function (response) {

            if (response.results !== 'undefined' && response.results.length === 1) {

                self.setState({ ...self.state, comboTipoListaContato: response, form: { ...self.state.form, tipoListaContato: response.results[0].value }, tipoListaContatoUnico: true });

            } else {

                self.setState({ ...self.state, comboTipoListaContato: response, tipoListaContatoUnico: false });
            }

        });
    }

    handleSave(e) {
        e.preventDefault(); if (this.state.loading) return;

        if (this.state.form.file === '' || isBlank(this.state.form.nomeArquivo) || this.state.form.tipoListaContato === "") {
            c.TOASTER_ERROR('Favor incluir o tipo, nome do arquivo e o arquivo.');

        } else {

            if (!isAuthenticated) {
                throw (c.MESSAGE_ERROR(c.AUTH_ERROR));
            }

            const _token = c.AUTH_HEADER(getToken());

            let data = new FormData();
            data.append('file', this.state.file);
            data.append('nomeArquivo', this.state.form.nomeArquivo);
            data.append('tipoListaContato', this.state.form.tipoListaContato);

            let url = `${c.API_BASE_URL}/list-validate/new`;
            let method = 'POST';

            if (this.state.idLista != '') {
                url = `${c.API_BASE_URL}/list-validate/update/${this.state.idLista}`;
                method = 'PUT';
            }

            const options = {
                method: method,
                body: data,
                headers: { 'Authorization': _token }
            };

            fetch(url, options).then(async (response) => {
                response.json().then(resp => {
                    if (resp.status >= 200 || resp.status <= 299) {
                        c.TOASTER_SUCCESS("Upload realizado com sucesso!");
                        this.props.history.push(c.CAMPAIGN_ROUTE + "/lista/validar");
                    } else {
                        c.TOASTER_ERROR(resp.message);
                    }
                });
            }).catch((ex) => {
                throw(ex);
            })
        }

    }

    handleChange(e) {
        const form = this.state.form;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }

    onChangeFile(e) {
        const form = this.state.form;

        form.file = e.target.files[0];

        this.setState({ file: e.target.files[0] });

        if (form.file != null) {
            document.getElementsByClassName('custom-file-label').item(0).textContent = form.file.name
        } else {
            document.getElementsByClassName('custom-file-label').item(0).textContent = "Selecione o arquivo";
        }
    }



    render() {
        const form = this.state.form;
        return (
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-5">
                    <Column>
                        <IBox>
                            <Title className="pt-5 text-center">
                                <h2 className="fs-20 fw-600 text-body">Upload de Arquivo para Validação</h2>

                                <h5 className="fs-14 fw-400 text-body">Tipos de Arquivos Permitidos: Formato de arquivos separados por ponto e vírgula (*.csv; .txt).</h5>
                                <TemPermissao permissao={ROLE_EMAIL}>
                                    <p />
                                    <h5 className="fs-14 fw-400 text-body">A primeira linha do arquivo da lista de <b>E-mail</b> deverá conter o nome dos campos: (nome; email...)</h5>
                                    <h5 className="fs-14 fw-400 text-body">O conteúdo do arquivo deverá ser separado por ponto e vírgula. Ex.: (Montreal; montreal@montreal.com.br)</h5>
                                    <p />
                                </TemPermissao>
                                <TemPermissao permissao={ROLE_SMS}>
                                    <p />
                                    <h5 className="fs-14 fw-400 text-body">A primeira linha do arquivo da lista de <b>SMS</b> deverá conter o nome dos campos: (nome; sms)</h5>
                                    <h5 className="fs-14 fw-400 text-body">O conteúdo do arquivo deverá ser separado por ponto e vírgula. Ex.: (Montreal; 31999999999)</h5>
                                    <p />
                                </TemPermissao>
                            </Title>

                            <Content className="p-3 border-0">
                                {/* FORMULÁRIO */}

                                <Row className="m-0 mb-5">
                                    <Column size="9" className="container mx-auto p-0">

                                        <Row className="mt-1">
                                            <Column size="4" className="px-1">
                                                <label for="tipoListaContato">Tipo da lista</label>
                                                <Select name="tipoListaContato" selected={form.tipoListaContato} data={this.state.comboTipoListaContato} disabled={this.state.tipoListaContatoUnico} onChange={this.handleChange} placeholder="Tipo da lista de contato" />
                                            </Column>
                                        </Row>

                                        <Row className="mt-4">
                                            <Column size="7" className="px-1">

                                                <div className="input-group">
                                                    <input type="text" name="nomeArquivo" value={form.nomeArquivo} onChange={this.handleChange} placeholder="Nome da Lista" className="form-control" />
                                                </div>

                                            </Column>

                                            <Column size="5" className="px-1">

                                                <div className="custom-file">
                                                    <input type="file" name="file" className="custom-file-input" id="validatedCustomFile" required onChange={this.onChangeFile} />
                                                    <label className="custom-file-label" for="validatedCustomFile">Selecione o arquivo</label>
                                                </div>

                                            </Column>
                                        </Row>

                                    </Column>
                                </Row>

                                {/* NAVEGAÇÃO */}
                                <Row className="m-0 mb-3">
                                    <Column size="auto" className="mx-auto">
                                        <div className="input-group">

                                            <Return to={c.CAMPAIGN_ROUTE + "/lista/validar"} className="mx-1" width="130px" />
                                            <Button onClick={this.handleSave} className="mx-1" width="130px">Próximo</Button>

                                            <div className="ml-4">
                                                {this.state.loading && (
                                                    <CircularProgress
                                                        size={30}
                                                        thickness={4}
                                                        color='inherit'
                                                        variant='indeterminate' />
                                                )}
                                            </div>

                                        </div>
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>
                    </Column>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth, lista: state.lista };
}
function mapDispatchToProps(dispatch) {
    return { actions: { lista: bindActionCreators(listaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListaUploadValidar));
